<template>
  <div class="table-tile" :title="name" :key="name" :class="{'active': showDetails }">
    <div class="table-tile__item">
      <b-form-checkbox
      class="open-rma"
      :class="{ disabled: item.qty_available === 0 }"
      v-model="showDetails"
      @change="toggleDetail"
      />
      <div class="table-tile__item__media">
        <img-product
        class="rma-product_img"
        :imgPath="image"
        :alt="name"
        size="LG"
        />
      </div>
      <div class="table-tile__item-block table-tile__item__info">
        <div class="table-tile__item__info__name">
          <span class="title" v-html="name"></span>
        </div>
         <div class="table-tile__item__info__selections">
          <div class="block-color" v-if="color">
            <span class="color-box" :style="swatchBackground"></span>
            <span class="color-label">{{color.value}}</span>
          </div>
          <div class="block-size" v-if="size">
            <span class="value">{{ size.value }}</span>
          </div>
        </div>
        <div class="table-tile__item__info__qty d-inline-flex">
          <span class="label">{{ $t('quantity-available') }}: </span>
          <span class="value t-regular">{{ item.qty_available }}</span>
        </div>
      </div>
    </div>
    <div class="add-more-info" ref="moreInfo" style="display: none;">
      <b-row>
        <b-col sm="4">
          <div class="add-more-info__input">
            <b-form-group id="groupQty">
              <BaseSelect
                selectClass="select-shadowed"
                :id="'qty_' + sku"
                :name="'qty_' + sku"
                v-model="item.dictionarySelected.qty_requested"
                :options="optionAvailable(item.qty_available)"
                :placeholder="$t('selectQty')"
                v-validate="'required'"
                :validations="[
                  {
                    condition: errors.has('qty_' + sku),
                    text: errors.first('qty_' + sku)
                  }
                ]"
              />
            </b-form-group>
          </div>
        </b-col>
        <!-- REASON -->
        <b-col sm="8">
          <div class="add-more-info__input">
            <b-form-group id="groupReason">
              <BaseSelect
                selectClass="select-shadowed"
                :id="'reason_' + sku"
                :name="'reason_' + sku"
                v-validate="'required'"
                :validations="[
                  {
                    condition: errors.has('reason_' + sku),
                    text: errors.first('reason_' + sku)
                  }
                ]"
                v-model="item.dictionarySelected.reason_id"
                :options="dictionary.reasons"
                :reduce="opt => opt.value"
                :placeholder="$t('selectReason')"
              />
            </b-form-group>
          </div>
        </b-col>
        <!-- CONDITION -->
        <b-col sm="6">
          <div class="add-more-info__input">
            <b-form-group id="groupCondition">
              <BaseSelect
                selectClass="select-shadowed"
                :id="'condition_' + sku"
                :name="'condition_' + sku"
                v-validate="'required'"
                :validations="[
                  {
                    condition: errors.has('condition_' + sku),
                    text: errors.first('condition_' + sku)
                  }
                ]"
                v-model="item.dictionarySelected.condition_id"
                :options="dictionary.conditions"
                :reduce="opt => opt.value"
                :placeholder="$t('selectCondition')"
              />
            </b-form-group>
          </div>
        </b-col>
        <!-- RESOLUTION -->
        <b-col sm="6">
          <div class="add-more-info__input">
            <b-form-group id="groupResolution">
              <BaseSelect
                selectClass="select-shadowed"
                :id="'resolution_' + sku"
                :name="'resolution_' + sku"
                v-validate="'required'"
                :validations="[
                  {
                    condition: errors.has('resolution_' + sku),
                    text: errors.first('resolution_' + sku)
                  }
                ]"
                v-model="item.dictionarySelected.resolution_id"
                :options="dictionary.resolutions"
                :reduce="opt => opt.value"
                :placeholder="$t('selectResolution')"
              />
            </b-form-group>
            <RmaProductsSizeSelector
              v-if="item.dictionarySelected.resolution_id === '1'"
              :name="'resolution_size_' + sku"
              v-validate="'required'"
              :validations="[
                {
                  condition: errors.has('resolution_size_' + sku),
                  text: errors.first('resolution_size_' + sku)
                }
              ]"
              v-model="item.dictionarySelected.resolution_sku"
              :sku="item.item_sku"
            />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import find from 'lodash/find'
import Config from 'config'
import ImgProduct from 'theme/components/Product/Image'
import BaseSelect from 'theme/components/Form/BaseSelect'
import RmaProductsSizeSelector from './RmaProductsSizeSelector'
import AddMessage from 'theme/components/MyAccount/Rma/AddMessage'
import BaseTextarea from 'theme/components/Form/BaseTextarea'

export default {
  name: 'newRmaProduct',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    dictionary: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      toggleDt: false,
      guest: false
    }
  },
  computed: {
    showDetails: {
      get () {
        return this.toggleDt
      },
      set (newValue) {
        this.toggleDt = newValue
        this.$set(this.item, 'showDetails', newValue)
      }
    },
    image () {
      return this.item.image_url
    },
    name () {
      return this.item.item_name
    },
    sku () {
      return this.item.item_sku
    },
    color () {
      if (this.item && this.item.selectedOptions) {
        return find(this.item.selectedOptions, { 'attribute_code': 'color' })
      }
      return false
    },
    size () {
      if (this.item && this.item.selectedOptions) {
        return find(this.item.selectedOptions, { 'attribute_code': 'size' })
      }
      return false
    },
    subtotal () {
      let subtotal = 0
      if (this.item && this.item.item_order_price) {
        subtotal = this.item.item_order_price * (this.item.qty_available === 0 ? 1 : this.item.qty_available)
      }
      return subtotal
    },
    swatchBackground () {
      if (this.color) {
        return {
          background: (this.color.type === 1 ? this.color.swatch : this.color.type === 2) ? `center / contain no-repeat url(${Config.API.swatchPath + this.color.swatch})` : ''
        }
      }
      return false
    }
  },
  mounted () {
    this.isGuest()
  },
  methods: {
    optionAvailable (maxQty) {
      return Array.from({ length: maxQty }, (v, k) => k + 1)
    },
    isValid () {
      return this.$validator.validateAll()
    },
    toggleDetail ({ alwaysTrue = false }) {
      const _this = this
      if (alwaysTrue) {
        this.toggleDt = alwaysTrue
        this.$emit('productOpened', true)
        $(_this.$refs.moreInfo).slideDown()
        return true
      } else {
        this.toggleDt = !this.showDetails
        this.$emit('productOpened', _this.toggleDt)
        $(_this.$refs.moreInfo).slideToggle(_this.toggleDt)
      }
    },
    isGuest () {
      const _this = this
      const id = this.$route.params.id
      const email = this.$route.params.email
      if (id && email) {
        _this.guest = true
      }
    }
  },
  components: {
    ImgProduct,
    BaseSelect,
    RmaProductsSizeSelector,
    AddMessage,
    BaseTextarea
  }
}
</script>
